export const nodeWidth = 200;
export const nodeHeight = 44;
